<script lang="ts">
  import { authRedirectNotice } from "$lib/auth/redirectNotice";
</script>

{#if $authRedirectNotice}
  <div role="alert" class="border-b border-amber-300 bg-amber-50 px-5 py-4 text-amber-950">
    <div class="mx-auto flex max-w-5xl items-center justify-between gap-4">
      <p>{$authRedirectNotice}</p>
      <button
        type="button"
        class="min-h-11 shrink-0 rounded px-3 font-semibold underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-950"
        on:click={() => authRedirectNotice.set(null)}>Dismiss</button>
    </div>
  </div>
{/if}
